import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	listConfigContentTitleTextLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.title-text-label',
		defaultMessage: 'Cards',
		description: 'A visible text label to be used as the title for the link cards config panel',
	},
	cardsInvalidMessage: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list',
		defaultMessage: 'Add cards',
		description:
			'Message for error shown to user when a value for cards is not provided or is invalid',
	},
	preamble: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.text.description',
		defaultMessage: 'Present links, images, and more. {link}',
		description: 'General helper text in Company hub configuration panel',
	},
	preambleWithoutSupportLink: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link',
		defaultMessage: 'Present links, images, and more.',
		description: 'General helper text in Company hub configuration panel',
	},
	preambleSupportLinkLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.text.description.link',
		defaultMessage: 'Learn more about cards.',
		description:
			'Link text to learn more about cards. Located in the general helper text in Company hub configuration panel',
	},
	stylesTabLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.styles-tab.label',
		defaultMessage: 'Styles',
		description: 'Label for the styles tab shown in the cards config panel, where clicking on it will open the styles section to configure the styles of the cards',
	},
	contentTabLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.content-tab.label',
		defaultMessage: 'Content',
		description: 'Label for the content tab shown in the cards config panel, where clicking on it will open the content section to configure the content of the cards',
	},
	styleSectionGeneralTitle: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.style.general.title',
		defaultMessage: 'General',
		description: 'Title for the general style section in the link cards config panel',
	},
	contentSectionDisplayOptionsTitle: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title',
		defaultMessage: 'Display options',
		description: 'Title for the display options style section in the link cards config panel',
	},
	layoutsTitle: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title',
		defaultMessage: 'Layouts',
		description: 'Title for the layouts section in the cards config panel',
	},
	layoutsCardsFixedImageHeightLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label',
		defaultMessage: 'Fixed image height',
		description: 'Label for the fixed image height layout option in the cards config panel',
	},
	layoutsCardsFixedImageHeightDescription: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description',
		defaultMessage: 'Image size is the same on all cards',
		description: 'Description for the fixed image height layout option in the cards config panel',
	},
	layoutsCardsFlexibleImageHeightLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label',
		defaultMessage: 'Flexible image height',
		description: 'Label for the flexible image height layout option in the cards config panel',
	},
	layoutsCardsFlexibleImageHeightDescription: {
		id: 'company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description',
		defaultMessage: 'Image size responds to the amount of text',
		description:
			'Description for the flexible image height layout option in the cards config panel',
	},
});
